app.controller("StudentDocsIndexController", ["$scope", "$stateParams", "$state", "DocumentsService", "usSpinnerService", "FreshModal",
    function ($scope, $stateParams, $state, DocumentsService, usSpinnerService, FreshModal) {

        $scope.docs = [];
        $scope.isEmptyDocs = false;
        $scope.type = $stateParams.type || 'sent';

        $scope.statuses = {
            unread: 'მომლოდინე',
            read: 'მუშავდება',
            done: "მზადაა",
            returned: "მუშავდება",
            resolved: "მუშავდება"
        };


        $scope.chancelleryStatus = {
            returned: "უარყოფილი"
        };

        $scope.getSentList = function () {
            $scope.isEmptyDocs = false;
            if($scope.type === 'sent') {
                DocumentsService.studentSentList({}).then(function (res) {
                    $scope.docs = res.data.docs;
                    $scope.isEmptyDocs = $scope.docs.length === 0;
                });
            } else {
                DocumentsService.studentReceivedList({}).then(function (res) {
                    $scope.docs = res.data.docs;
                    $scope.docs.forEach(doc => doc.documentStatus = 'done');
                    $scope.isEmptyDocs = $scope.docs.length === 0;
                });
            }
        };
        $scope.getSentList();

        $scope.getDocuments = function (type) {
            $scope.type = type;
            $state.go(".", {
                page: $stateParams.page,
                type: type,
            });
        };

        $scope.create = function () {
            FreshModal.open({
                controller: "StudentDocsCreateController",
                templateUrl: _pb + 'student-new/docs/student-docs-create.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {mode: 'create'};
                    }
                }
            }).then(function () {
                $scope.getSentList();
            }, function () {
            });
        };

        $scope.details = function (doc) {
            if($scope.type === 'sent') {
                FreshModal.open({
                    controller: "StudentDocsCreateController",
                    templateUrl: _pb + 'student-new/docs/student-docs-create.html',
                    size: "md",
                    resolve: {
                        params: function () {
                            return {mode: 'show', doc: doc};
                        }
                    }
                }).then(function () {
                }, function () {
                });
            } else {
                FreshModal.open({
                    controller: "StudentDocsViewController",
                    templateUrl: _pb + 'student-new/docs/student-docs-view.html',
                    size: "md",
                    resolve: {
                        params: function () {
                            return {mode: 'show', doc: doc};
                        }
                    }
                }).then(function () {
                }, function () {
                });
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.showComments = function (comments, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "StudentDocsCommentModalController",
                templateUrl: _pb + 'student-new/docs/student-docs-comment-modal.html',
                resolve: {
                    comments: function () {
                        return comments;
                    }
                }
            }).then(function (result) {
            }, function (result) {
            });
        };

        $scope.generateTooltip = function (record) {
            if (record.documentStatus === "done") {
                return 'დასრულებული'
            } else if (record.documentStatus === 'returned' || record.chancelleryStatus === 'returned') {
                return 'უარყოფილი'
            } else {
                return 'მიმდინარე'
            }
        };

        $scope.generateClass = function (record) {
            if (record.documentStatus === "done") {
                return 'passed-sub'
            } else if (record.documentStatus === 'returned' || record.chancelleryStatus === 'returned') {
                return 'critical-subject'
            } else {
                return 'important-subject'
            }
        };
    }
]);
